import Event from './helper'
import semver from 'semver'
import {getRootData} from "./getRootData"
export default class BtnRoot {
  constructor(app, option) {
    this.event = new Event()
    this.option = option
    this.registerDirecitve(app)
    this.arr = []
    this.i = false
  }
  renderFun() {
    this.arr.forEach(({el,binding,vnode}, index) => {
      this.renderBtn(el, binding, index)
      this.event.addEventListener('load', () => {
        this.renderBtn(el, binding, index)
      })
      if (vnode.props && vnode.props.onClick) {
        el.addEventListener('mousedown', () => {
          sessionStorage.setItem('btn-code', binding.value)
          vnode.props.onClick()
        })
      }
    })
    
  }
  registerDirecitve(app) {
    // 指令注册
    let eventKey = 'mounted'
    if (app.version.split('.')[0] < 3) {
      eventKey = 'inserted'
    }
    app.directive('btnroot', {
      created(el, binding, vnode) {
        el.style.display = 'none'
      },
      [eventKey]: async(el, binding, vnode) => {
        this.arr.push({el, binding,vnode})
        if (!this.i){
          this.i = true
          this.instance = await getRootData(this.option)
          this.renderFun()
        }
      }
    })
  }
  renderBtn (el, binding, index)  {
    // el 当前绑定的元素 binding.value指令的绑定值
    // const value = sessionStorage.getItem('permission_button')
    // let permissionObj = value && JSON.parse(value)
    let permissionObj = this.instance
    try {
      if (permissionObj && !permissionObj[binding.value]) {
          el.parentNode.removeChild(el)

      } else {
        el.style.display = ""
      }
      if (index === this.arr.length - 1){
        this.arr = []
        this.i = false
      } 
    } catch (error) {
      console.log(error)
    }
  }
  dispatchEvent(value ){
    sessionStorage.setItem('permission_button', JSON.stringify(value))
    this.event.dispatchEvent('load')
  }
}